<section class="form-wrapper">
  <mat-card appearance="outlined" class="form-wrapper__settings">
    <div class="top-wrapper">
      <button mat-raised-button color="primary" type="button" (click)="openCopyDialog('accessory')">COPY
      </button>

      @if (copiedItem) {
        <span class="form-wrapper__copy-hint">{{ copiedItem }} copied</span>
      }
    </div>
    <mat-card-header>
      <mat-card-title>
        Accessory
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      @if (showLoading) {
        <div class="form-wrapper__loading">
          <mat-progress-spinner mode="indeterminate" [diameter]=20></mat-progress-spinner>
        </div>
      }

      <div class="container" novalidate>
        <form [formGroup]="accessoryForm" (ngSubmit)="onSubmit()" class="form">

          <mat-form-field class="form-element">
            <mat-label>name</mat-label>
            <input matInput placeholder="name" data-testid="name" formControlName="name">
            @if (accessoryForm.get('name').hasError('required')) {
              <mat-error>The field name is required</mat-error>
            }
            @if (accessoryForm.get('name').hasError('duplicateNames')) {
              <mat-error>This name is already used
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="form-element">
            <mat-label>type</mat-label>
            <input matInput placeholder="type" data-testid="type" formControlName="type">
          </mat-form-field>

          <div class="form-element" formArrayName="extraAttributes">
            <mat-card-subtitle>Add Extra Attributes
              <mat-icon color="primary" type="button"
                (click)="addExtraAttribute(); $event.stopPropagation();">add_circle
              </mat-icon></mat-card-subtitle>
              @for (qc of extraAttributes.controls; track qc; let i = $index) {
                <div [formGroupName]="i" class="query-row">
                  <mat-form-field appearance="fill" class="form-element">
                    <mat-label>Attribute</mat-label>
                    <input matInput formControlName="field" placeholder="Enter field" />
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="form-element">
                    <mat-label>Value</mat-label>
                    <input matInput formControlName="value" placeholder="Enter value" />
                  </mat-form-field>
                  <button mat-icon-button color="warn" type="button"
                    (click)="removeExtraAttribute(i); $event.stopPropagation();">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }

            </div>

            <mat-form-field class="form-element">
              <mat-label>status</mat-label>
              <input matInput placeholder="status" data-testid="status" formControlName="status">
            </mat-form-field>

            <mat-form-field class="form-element">
              <mat-label>comment</mat-label>
              <input matInput placeholder="comment" data-testid="comment" formControlName="comment">
            </mat-form-field>

            <mat-form-field class="form-element">
              <mat-label>category</mat-label>
              <input matInput placeholder="category" formControlName="category">
            </mat-form-field>

            <mat-form-field class="form-element">
              <mat-label>controller</mat-label>
              <mat-select formControlName="controller" multiple>
                @for (controller of ['PS', 'PS2', 'PS3', 'PSk2', 'PSk3']; track controller) {
                  <mat-option [value]="controller">{{ controller }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="form-element">
              <mat-label>pump_family</mat-label>
              <mat-select formControlName="pump_family" multiple>
                @for (family of ['Submersible', 'Surface']; track family) {
                  <mat-option [value]="family">{{ family }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <app-pump-system-portfolio formControlName="portfolio_rights"
            class="form-element"></app-pump-system-portfolio>

            <mat-form-field class="form-element">
              <mat-label>pump_type</mat-label>
              <mat-select formControlName="pump_type" multiple>
                @for (type of ['Default', 'Custom', 'GRUNDFOS', 'Lowara', 'C', 'CS', 'BOOST', 'HR', 'AHR', 'HRE', 'SHRE',
                  'AHRE']; track type) {
                  <mat-option [value]="type">{{ type }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-slide-toggle formControlName="secondary_accessory" labelPosition="before" class="bottom-spacing">
              <mat-card-subtitle>Is this a secondary accessory to another accessory?
              </mat-card-subtitle>
            </mat-slide-toggle>
            @if (accessoryForm.controls['secondary_accessory'] && accessoryForm.controls['secondary_accessory'].value ===
              true) {
              <mat-form-field class="form-element sub-element">
                <mat-label>secondary_to</mat-label>
                <mat-select formControlName="secondary_to" multiple required>
                  @for (accessory of accessoryList; track accessory) {
                    <mat-option [value]="accessory">{{ accessory.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }




            <app-packaging-select data-testid="packaging" formControlName="packaging"></app-packaging-select>

            <mat-form-field class="form-element">
              <mat-label>item_no_1</mat-label>
              <input matInput placeholder="item_no_1" data-testid="item_no_1" formControlName="item_no_1">
            </mat-form-field>

            <mat-form-field class="form-element">
              <mat-label>product_name_1</mat-label>
              <input matInput placeholder="product_name_1" data-testid="product_name_1" formControlName="product_name_1">
            </mat-form-field>


            <div class="form-element bottom-spacing">
              <app-overview-editor [jsonInput]="overview" (overviewChange)="onOverviewChange($event)">
              </app-overview-editor>
            </div>
            <div class="form-element">
              <button mat-raised-button color="primary" type="submit" class="button" data-testid="submit"
                [disabled]="!accessoryForm.valid">Submit Form
              </button>
            </div>

          </form>
        </div>

      </mat-card-content>
    </mat-card>
  </section>